var _this = this,
  _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB-JOB1/src/components/Animation/Animation.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { useState, useEffect, useMemo } from 'react';
import { Transition } from 'react-transition-group';
import Fade from './fade';
import Lottie from '../../core/components/Lottie';
import { testIdProps } from '../../helpers';
import { Wrapper } from './style';
var DEFAULT_SIZE = '40px';
var Action = {
  PLAY: 'play',
  PAUSE: 'pause',
  STOP: 'stop'
};
var coloredSource = function coloredSource(source, color) {
  var r = /^#?(..)(..)(..)(..)?$/.exec(color);
  var arrColor = [r[1], r[2], r[3], r[4] || 'FF'].map(function (c) {
    return parseInt(c, 16) / 255;
  });
  return JSON.parse(JSON.stringify(source).replace(/"k":\[[0.\d]+,[0.\d]+,[0.\d]+,1\]/g, "\"k\":[".concat(arrColor, "]")));
};
var Animation = function Animation(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    fadeIn = _useState2[0],
    setFadeIn = _useState2[1];
  var color = props.color,
    loop = props.loop,
    action = props.action,
    size = props.size,
    source = props.source,
    segments = props.segments,
    onComplete = props.onComplete,
    rest = _objectWithoutProperties(props, ["color", "loop", "action", "size", "source", "segments", "onComplete"]);
  useEffect(function () {
    setFadeIn(action !== Action.STOP);
  }, [action]);
  var animationData = useMemo(function () {
    return color ? coloredSource(source, color) : source;
  }, [color, source]);
  useEffect(function () {
    // Reset fade transition if animation source change
    setFadeIn(false);
    setTimeout(function () {
      return setFadeIn(true);
    }, 0);
  }, [source]);
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    size: size || DEFAULT_SIZE
  }, testIdProps(rest), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(Transition, {
    "in": fadeIn,
    mountOnEnter: true,
    unmountOnExit: true,
    timeout: 200,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 7
    }
  }, function (state) {
    return /*#__PURE__*/React.createElement(Fade, {
      state: state,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 62,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(Lottie, {
      "data-testid": "lottieId",
      animationData: animationData,
      config: {
        loop: loop
      },
      play: action !== Action.STOP,
      pause: action === Action.PAUSE,
      segments: segments,
      height: size || DEFAULT_SIZE,
      width: size || DEFAULT_SIZE,
      onComplete: onComplete,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 63,
        columnNumber: 13
      }
    }));
  }));
};
Animation.defaultProps = {
  action: Action.PLAY,
  loop: true
};
export default Animation;